import React from 'react';
import './HomePage.css';
import Header from './Header';
import Hero from './Hero';
import TrustBar from './TrustBar';
import Body from './Body';
import OurTeam from './OurTeam';
import ParallaxBar from './ParallaxBar';
import Contact from './Contact';
import PartnersSection from './Partners';
import Footer from './Footer';
import usePageMeta from '../seo/usePageMeta';

const HomePage = () => {
  usePageMeta({
    title: 'Ambulanter Pflegedienst Eitorf | Cura Care GmbH',
    description:
      'Cura Care ist Ihr ambulanter Pflegedienst in Eitorf: Behandlungs- und Grundpflege, Wundmanagement, Palliativpflege, Verhinderungspflege und Pflegeberatung. 24h-Rufbereitschaft: 02243 8455323.',
    path: '/'
  });

  return (
    <div className="curacare-homepage">
      <Header />
      <Hero />
      <TrustBar />
      <Body />
      <OurTeam />
      <ParallaxBar />
      <Contact />
      <PartnersSection />
      <Footer />
    </div>
  );
};

export default HomePage;
